import { IconProps } from './IconProps';

export const TinyTimer = ({
  className,
  style,
  fill = 'black',
  width = 14,
  height = 14,
}: {
  className?: string;
  style?: Record<string, unknown>;
  fill?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      className={className}
      style={style}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6111 12.25C10.802 12.25 10.9608 12.0952 10.9937 11.8911L11 11.8125V10.5C11 8.97557 10.2298 7.65338 9.10335 6.99908C10.2298 6.34662 11 5.02443 11 3.5V2.1875L10.9937 2.10886C10.9608 1.90477 10.802 1.75 10.6111 1.75C10.3963 1.75 10.2222 1.94588 10.2222 2.1875V2.40625H4.77778V2.1875L4.77151 2.10886C4.73858 1.90477 4.5798 1.75 4.38889 1.75C4.17411 1.75 4 1.94588 4 2.1875L4 3.5L4.00495 3.71076C4.04773 4.61983 4.36632 5.47109 4.90182 6.13817C5.56109 6.95945 6.49682 7.4375 7.5 7.4375C8.4245 7.4375 9.24143 7.95608 9.73346 8.74876L5.26591 8.74958C5.331 8.64472 5.40214 8.54408 5.47905 8.44828C5.623 8.26896 5.61048 7.9923 5.45108 7.83036C5.29168 7.66842 5.04577 7.6825 4.90182 7.86183C4.36632 8.52891 4.04773 9.38017 4.00495 10.2892L4 10.5V11.8125C4 12.0541 4.17411 12.25 4.38889 12.25C4.5798 12.25 4.73858 12.0952 4.77151 11.8911L4.77778 11.8125V11.5938H10.2222V11.8125C10.2222 12.0541 10.3963 12.25 10.6111 12.25ZM10.1095 4.37481L4.89047 4.37508C4.81646 4.0951 4.77778 3.80102 4.77778 3.5V3.28125H10.2222V3.5L10.2182 3.66802C10.2064 3.91233 10.1692 4.14902 10.1095 4.37481ZM7.5 6.5625C6.71919 6.5625 5.99237 6.19117 5.47905 5.55172C5.40193 5.45566 5.33061 5.35473 5.26537 5.24956L9.734 5.25036C9.24203 6.04353 8.42484 6.5625 7.5 6.5625ZM10.2222 10.7188H4.77778V10.5C4.77778 10.1987 4.81654 9.90429 4.8907 9.62405L10.1093 9.62431C10.1692 9.85036 10.2064 10.0874 10.2182 10.332L10.2222 10.5V10.7188Z"
        fill={fill}
        stroke="black"
        stroke-width="0.175"
      />
    </svg>
  );
};

